import React from "react"
import game from "quoridor.png"

const Quoridor = (props) => <img src={game} className="game" {...props} />

export default Quoridor
